import {  User } from '../user';


export class UserSerializer {
    fromJson(json: any): User {
        const data = new User();
        data.value = json.id;
        data.id=json.id;
        data.label = json.lastName ? json.firstName +" "+json.lastName: json.firstName;
        data.name = json.name;
        data.password = json.password;
        data.firstName = json.firstName;
        data.lastName = json.lastName;
        data.role = json.robRole;
        data.token = json.token;
        data.fullName=json.lastName? json.firstName + ' ' + json.lastName : json.firstName;
        return data;
    }

    toJson(data: User): any {
        return {
            id: data.id,
            name: data.name,
            password: data.password,
            firstName: data.firstName,
            lastName: data.lastName,
            role: data.role,
            fullName: data.fullName,
            token: data.token
        };
    }
}